import { render, staticRenderFns } from "./AddBrandDialogVersion2.vue?vue&type=template&id=fec0f5a8&scoped=true"
import script from "./AddBrandDialogVersion2.vue?vue&type=script&lang=js"
export * from "./AddBrandDialogVersion2.vue?vue&type=script&lang=js"
import style0 from "./AddBrandDialogVersion2.vue?vue&type=style&index=0&id=fec0f5a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec0f5a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fec0f5a8')) {
      api.createRecord('fec0f5a8', component.options)
    } else {
      api.reload('fec0f5a8', component.options)
    }
    module.hot.accept("./AddBrandDialogVersion2.vue?vue&type=template&id=fec0f5a8&scoped=true", function () {
      api.rerender('fec0f5a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/dialog/AddBrandDialogVersion2.vue"
export default component.exports